/* istanbul ignore file */
import { ComposedTheme } from '@glu/theming';

export default ({ palette, typography }: ComposedTheme) => ({
  // @theming labelText: Dropdown/tooltip border color, type: color
  border: palette.form.border,
  // @theming labelText: Breadcrumb Font, type: fontFamily
  breadcrumbFontFamily: typography.h3.fontFamily,
  // @theming labelText: Badge color, type: color
  clearIconFill: palette.grey.G400,
  // @theming labelText: Badge hover color, type: color
  clearIconFillHover: palette.primary.light,
  error: {
    // @theming labelText: Error border color, type: color
    borderColor: palette.form.error,
  },
  // @theming labelText: Font family, type: fontFamily
  fontFamily: typography.fontFamily,
  // @theming labelText: Options font size, type: pixel
  fontSize: 16,
  // @theming labelText: Select font weight, type: string
  fontWeight: typography.fontWeight,
  // Partially unused - see GLU-7496
  // @theming labelText: Filter suggestion background , type: color
  highlightBg: '#cbe4ff',
  // Partially unused - see GLU-7496
  // @theming labelText: Hover background color, type: color
  hoverBg: palette.highlightBackground,
  // @theming labelText: Background color, type: color
  background: palette.background,
  // @theming labelText: Text color, type: color, backgroundColor: dropdown.background
  text: palette.text.dark,
  // @theming labelText: Placeholder color, type: color, backgroundColor: dropdown.background
  placeholderColor: palette.text.dark,
  /* @theming labelText: Group options header color, type: color,
  backgroundColor: dropdown.background
  */
  optionHeader: palette.text.midGray,
  // @theming labelText: Breadcrumb color, type: color, backgroundColor: dropdown.background
  breadcrumbColor: palette.primary.normal,
  // @theming labelText: Select caret color , type: color, backgroundColor: dropdown.background
  iconFill: palette.text.dark,
  // @theming labelText: Focus outline color, type: color
  focusColor: palette.focus.normal,
  // @theming labelText: Disabled background color, type: color
  disabledBg: '#EDEDED',
  // Is being used in classes but is getting applied - see GLU-7496
  // @theming labelText: Disabled text color, type: color
  disabledText: palette.text.midGray,
  dark: {
    // @theming labelText: Dark mode background color, type: color
    background: palette.primary.darkBackground,
    // @theming labelText: Dark mode breadcrumb color, type: color
    breadcrumbColor: palette.primary.light,
    // @theming labelText: Dark mode error border color, type: color
    errorBorderColor: '#FF9494',
    // @theming labelText: Dark mode filter suggestion background , type: color
    highlightBg: '#465575',
    // @theming labelText: Dark mode hover background color, type: color
    hoverBg: '#465575',
    /* @theming labelText: Dark mode select caret color , type: color,
    backgroundColor: dropdown.dark.background
     */
    iconFill: palette.text.light,
    /* @theming labelText: Dark mode placeholder color, type: color,
    backgroundColor: dropdown.dark.background
    */
    placeholderColor: palette.grey.G100,
    /* @theming labelText: Dark mode text color, type: color,
    backgroundColor: dropdown.dark.background
    */
    text: palette.text.light,
    // @theming labelText: Dark mode focus outline color, type: color
    darkFocusColor: palette.focus.dark,
    /* @theming labelText: Dark mode group options header color, type: color,
    backgroundColor: dropdown.dark.background
    */
    optionHeader: palette.text.light,
  },
  checkbox: {
    // @theming labelText: Checkbox border color, type: color
    borderColor: palette.colors.doveGray,
    // @theming labelText: Checkbox selected color, type: color
    selectedColor: palette.colors.lochmara,
    /* @theming labelText: Checkbox check color, type: color,
      backgroundColor: dropdown.checkbox.selectedColor
    */
    checkColor: palette.text.light,
    // @theming labelText: Checkbox focus shadow color, type: color
    shadowColor: palette.colors.doveGray,
    dark: {
      // @theming labelText: Dark mode checkbox border color, type: color
      borderColor: palette.text.light,
      // @theming labelText: Dark mode checkbox selected color, type: color
      selectedColor: palette.text.light,
      /* @theming labelText: Dark mode checkbox check color, type: color,
        backgroundColor: dropdown.checkbox.dark.selectedColor
      */
      checkColor: palette.colors.pickledBluewood,
    },
  },
});
